import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class HomePage extends Component {
  constructor(props) {
    console.log(props);
    super(props);
  }
  render() {
    return (
            <div class="container-fluid">
                <div class="container">
                    <div class="row">
                        <div class="col-md">

        <h4>Version Management</h4>

        <p>
          <a href="/waves/versions" className="ContentTitle">
             Versions
          </a>
        </p>
        <p>
          <a href="/waves/create-version" className="ContentTitle">
            Create A Version
          </a>
        </p>
        <p>
          <a href="/waves/create-revision" className="ContentTitle">
            Add A Version (revision)
          </a>
        </p>
        <p>
          <a href="/waves/checked-out-files" className="ContentTitle">
          Checked Out Files
          </a>
        </p>
        <p>
          <a href="/waves/checkout" className="ContentTitle">
          Checkout
          </a>
        </p>
        <p>
          <a href="/waves/version-labels" className="ContentTitle">
          Version Labels
          </a>
        </p>
        <p>
          <a href="/waves/create-label" className="ContentTitle">
          Create Label
          </a>
        </p>
        	</div>
       		</div>
       		</div>
       		</div>
    );
  }
}
